<!-- Uploaded to: SVG Repo, www.svgrepo.com, Transformed by: SVG Repo Mixer Tools -->
<svg
	width="30px"
	height="30px"
	style="flex: 0 0 30px"
	viewBox="0 0 24 24"
	id="Layer_1"
	data-name="Layer 1"
	xmlns="http://www.w3.org/2000/svg"
	fill="currentColor"
	stroke="currentColor"
	stroke-miterlimit="10"
	stroke-width="0.5"
	class="icon line-color"
>
	<g id="SVGRepo_bgCarrier" stroke-width="0" />

	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

	<g id="SVGRepo_iconCarrier">
		<defs>
			<style>
				.cls-1 {
					fill: none;
					stroke: currentColor;
					stroke-miterlimit: 10;
					stroke-width: 0.624;
				}
			</style>
		</defs>

		<path
			class="cls-1"
			d="M17.1,19.59a6.34,6.34,0,0,1-4.54,1.91H12V4.23l5.47,6.58A6.56,6.56,0,0,1,17.1,19.59Z"
		/>

		<path
			class="cls-1"
			d="M12,2.5V19.77h-.56A6.36,6.36,0,0,1,6.9,17.86a6.55,6.55,0,0,1-.37-8.78Z"
		/>

		<line class="cls-1" x1="12" y1="12.86" x2="15.89" y2="8.98" />

		<line class="cls-1" x1="12" y1="18.91" x2="18.48" y2="12.43" />
	</g>
</svg>
